import { Biller, Recipient } from './Recipient'
import { OrderItemStatus, OrderStatus, PaymentMethod } from '../config/enums'

export interface StatusHistoryItem {
  status: string
  date: Date
}

export interface OrderItem {
  vendor: {
    id: string
    name: string
  }
  item: {
    id: string
    name: string
    variantName: string
    thumbImageUrl: string
  }
  gift: {
    id: string
    name: string
    thumbImageUrl: string
  }
  currency: string
  unitPrice: number
  quantity: number
  totalPrice: number
  shippingInfo: {
    courier: string
    fee: number
    minArrivalDate: Date
    maxArrivalDate: Date
  }
  status: OrderItemStatus
  statusHistory: StatusHistoryItem[]
  cancelReason: string
}

interface InstallmentInfo {
  term: number
  dueEvery: number
  monthsPaid: number
  isPaymentDue: boolean
  pendingConfirmation: boolean
}

export interface Order {
  id: string
  consumerId: string
  orderNumber: string
  status: OrderStatus
  totalAmount: number
  paymentType: string
  paymentApproved: boolean
  orderItems: OrderItem[]
  biller: Biller
  recipient: Recipient
  createdAt: Date
  paymentMethod: PaymentMethod
  installmentId?: string
  installmentInfo?: InstallmentInfo
}

export const orderConverter: firebase.firestore.FirestoreDataConverter<Order> = {
  toFirestore: order => {
    return {
      consumerId: order.consumerId,
      orderNumber: order.orderNumber,
      status: order.status,
      totalAmount: order.totalAmount,
      paymentType: order.paymentType,
      paymentApproved: order.paymentApproved,
      orderItems: order.orderItems,
      biller: order.biller,
      recipient: order.recipient,
      paymentMethod: order.paymentMethod,
      installmentId: order.installmentId,
      installmentInfo: order.installmentInfo
    }
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data()

    let orderItemsConverted: OrderItem[] = []
    data.orderItems.forEach((orderItem: OrderItem) => {
      orderItemsConverted.push({
        ...orderItem,
        shippingInfo: {
          ...orderItem.shippingInfo,
          minArrivalDate: new Date(
            String(orderItem.shippingInfo.minArrivalDate)
          ),
          maxArrivalDate: new Date(
            String(orderItem.shippingInfo.maxArrivalDate)
          )
        }
      })
    })

    return {
      id: snapshot.id,
      consumerId: data.consumerId,
      orderNumber: data.orderNumber,
      status: data.status,
      totalAmount: data.totalAmount,
      paymentType: data.paymentType,
      paymentApproved: data.paymentApproved,
      orderItems: orderItemsConverted,
      biller: data.biller,
      recipient: data.recipient,
      createdAt: data.createdAt.toDate(),
      paymentMethod: data.paymentMethod,
      installmentId: data.installmentId,
      installmentInfo: data.installmentInfo
    }
  }
}
